import { ThemeProvider } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { themeUCI, themeLMU, themeUCSB, themeK12One, themeBC } from './theme';

interface CustomThemeProviderProps {
  children: React.ReactNode;
}

export const CustomThemeProvider: React.FC<CustomThemeProviderProps> = ({ children }) => {
  const [CustomTheme, setTheme] = useState(themeBC);
  const location = useLocation();

  // for testing
  useEffect(() => {
    console.log("Location:", location.pathname); 
  }, [location]);

  const AWSUSD = location.pathname.includes("students") || location.pathname.includes("teachers");
  const UCI = location.pathname.includes("uci");
  const LMU = location.pathname.includes("lmu");
  const UCSB = location.pathname.includes("ucsb");
  const BC = location.pathname.includes("bc");

  useEffect(() => {
    if (AWSUSD) {
      setTheme(themeK12One);
    } else if (UCI) {
      setTheme(themeUCI);
    } else if (LMU) {
      setTheme(themeLMU);
    } else if (UCSB) {
      setTheme(themeUCSB);
    } else if (BC) {
      setTheme(themeBC);
    } else {
      // defaulting to BC for now just to show styling
      setTheme(themeBC);
    }
  }, [AWSUSD, BC, LMU, UCI, UCSB]);

  return <ThemeProvider theme={CustomTheme}>{children}</ThemeProvider>;
};
